export default {
    name: 'favoritesservice',
    dependencies: ['xhrservice', 'trackingservice'],
    callable(xhr, trackingService) {
        const FAVORITE_ADDED_TRACKING_EVENT_NAME = 'collect.add-favorite.done';
        const FAVORITE_REMOVED_TRACKING_EVENT_NAME =
            'collect.remove-favorite.done';
        const LIST_CREATED_TRACKING_EVENT_NAME =
            'collect.create-favorite-list.done';
        const LIST_DELETED_TRACKING_EVENT_NAME =
            'collect.delete-favorite-list.done';
        const LIST_RENAMED_TRACKING_EVENT_NAME =
            'collect.rename-favorite-list.done';

        function toggleFavorite(folderId, adId, saveNew) {
            const togglePromise = xhr
                .request({
                    url: createFolderAndAdIdUrlString(folderId, adId),
                    method: saveNew ? 'PUT' : 'DELETE',
                    type: 'json',
                })
                .then(response => {
                    if (saveNew) {
                        trackKpi(FAVORITE_ADDED_TRACKING_EVENT_NAME);
                        trackingService.trackEventObject({
                            ecType: 'AD',
                            ecCategory: 'NoOfSeenByFolderMembers',
                            eventData: {
                                'ad.id': adId,
                            },
                        });
                    } else {
                        trackKpi(FAVORITE_REMOVED_TRACKING_EVENT_NAME);
                    }

                    return response;
                })
                .catch(xhr => {
                    console.error(xhr.statusText);
                    const action = saveNew ? 'legge til' : 'slette';
                    return Promise.reject(
                        `Uffda! Det skjedde en feil da vi prøvde å ${action} annonsen. Prøv igjen`
                    );
                });

            return Promise.all([
                togglePromise,
            ]).then(([toggleVal, favNotifVal]) => {
                toggleVal.favNotif = favNotifVal;
                return toggleVal;
            });
        }

        function createList(name) {
            const url = new URL('/user/favorite/lists.json', document.baseURI);
            url.searchParams.set('folderName', name);

            return xhr
                .request({
                    url: url.toString(),
                    method: 'POST',
                    type: 'json',
                })
                .then(listId => {
                    track(LIST_CREATED_TRACKING_EVENT_NAME);
                    return listId;
                })
                .catch(xhr => {
                    let errorMessage;
                    if (xhr.status === 409) {
                        // 409 conflict
                        errorMessage =
                            'Uffda! Det skjedde en feil. Prøv et annet navn.';
                    } else {
                        errorMessage =
                            'Uffda! Det skjedde en feil da vi prøvde å lagre lista';
                    }

                    return Promise.reject(errorMessage);
                });
        }

        function deleteList(folderId) {
            const url = new URL('/user/favorite/lists.json', document.baseURI);
            url.searchParams.set('folderId', folderId);

            return xhr
                .request({
                    url: url.toString(),
                    method: 'DELETE',
                })
                .then(() => {
                    track(LIST_DELETED_TRACKING_EVENT_NAME);
                })
                .catch(() =>
                    Promise.reject(
                        'Usjda! Noe gikk galt da vi prøvde å slette lista'
                    )
                );
        }

        function renameList(folderId, name) {
            const url = new URL('/user/favorite/rename.json', document.baseURI);
            url.searchParams.set('folderId', folderId);
            url.searchParams.set('folderName', name);

            return xhr
                .request({
                    url: url.toString(),
                    method: 'PUT',
                })
                .then(() => {
                    track(LIST_RENAMED_TRACKING_EVENT_NAME);
                })
                .catch(() =>
                    Promise.reject(
                        'Usjda! Noe gikk galt da vi prøvde å lagre det nye navnet'
                    )
                );
        }

        function getFavoriteListUrl(folderId) {
            return `/user/favorite/favorites.html?folderId=${folderId}`;
        }

        function shareList() {
            const folderId = new URL(document.baseURI).searchParams.get(
                'folderId'
            );

            const url = new URL('/user/favorite/share.json', document.baseURI);
            url.searchParams.set('folderId', folderId);

            return xhr.request({
                url: url.toString(),
                method: 'POST',
            });
        }

        function getFolderSearchResultItems(currentAdId) {
            const url = new URL(
                '/favoritter/searchfavorites.json',
                document.baseURI
            );
            url.searchParams.append('adId', currentAdId);

            return xhr.request({
                url: url.toString(),
                method: 'GET',
            });
        }

        function createFolderAndAdIdUrlString(folderId, adId) {
            const url = new URL(
                '/user/favorite/favorite.json',
                document.baseURI
            );
            url.searchParams.set('folderId', folderId);
            url.searchParams.set('finnkode', adId);
            return url.toString();
        }

        function track(eventName) {
            trackingService.trackEvent(eventName, 'start,success', '');
        }

        function trackKpi(eventName) {
            trackingService.trackEvent(eventName, 'start,success', 'activity');
        }

        const exports = {
            toggleFavorite,
            createList,
            deleteList,
            renameList,
            getFavoriteListUrl,
            shareList,
            getFolderSearchResultItems,
        };

        return exports;
    },
};



// WEBPACK FOOTER //
// ./services/favoritesservice.js